import { http } from '@/services/http'

function mapDate(params) {
  let obj = {
    from: new Date(params.from).toISOString(),
    to: new Date(params.to).toISOString()
  }
  return {
    ...params,
    ...obj
  }
}
export default {
  getOverview(params) {
    return http.get('/overview', { params: mapDate(params) })
  },
  getPdf(params) {
    return http.get('/overview/pdf', {
      responseType: 'arraybuffer',
      params: mapDate(params)
    })
  },
  getCsv(params) {
    return http.get('/overview/csv', {
      params: mapDate(params)
    })
  },
  getCompetitions(params) {
    return http.get('/overview/competition', {
      params: mapDate(params)
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/api/overview.js